var map = {
	"./ananthi.webp": 39671,
	"./arumugam.webp": 30991,
	"./balasubramanie.webp": 15849,
	"./deepa.webp": 45661,
	"./jamunadevi.webp": 12760,
	"./karthika.webp": 50117,
	"./malathieswaran.webp": 12637,
	"./maragatham.webp": 8905,
	"./rukumanikhandhan.webp": 14965,
	"./sathiyapriya.webp": 77016,
	"./shanmugapriya.p.webp": 42879,
	"./srithar.webp": 82131,
	"./suganthe.webp": 10825,
	"./varshini.webp": 97424,
	"./vijay.webp": 31215,
	"./yuvarani.webp": 57987
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41872;